import type { PathMode } from './path.ts';

/**
 * Which adventure layout the child is on. `games` is the island: six stops that each play a
 * minigame chosen for that set. `skills` (the seven drill stops) and `words` (one stop per word)
 * are the layouts it replaced — kept, not deleted, because a games island falls back to a skill
 * stop's drill wherever a slot has no playable format, and because a profile part-way through
 * one should still be able to finish it. The choice is remembered per device so Home, the Result
 * screen and "back to the path" all return to the same layout.
 */
const KEY = 'ezishizi:adventure-mode';

export const isPathMode = (v: unknown): v is PathMode =>
  v === 'games' || v === 'skills' || v === 'words';

export function getAdventureMode(): PathMode {
  try {
    const v = typeof localStorage === 'undefined' ? null : localStorage.getItem(KEY);
    return isPathMode(v) ? v : 'games';
  } catch {
    return 'games';
  }
}

export function setAdventureMode(mode: PathMode): void {
  try {
    if (typeof localStorage !== 'undefined') localStorage.setItem(KEY, mode);
  } catch {
    /* private mode: this visit only */
  }
}
